export const incidentStatus = {
  OPEN: 1,
  CLOSED: 2,
  CLOSURE_INITIATED: 3,
  CLOSURE_COMPLETED: 4,
};

export const taskStatus = {
  COMPLETED: 1,
  INPROGRESS: 2,
};
